// extracted by mini-css-extract-plugin
export var block = "itemRowBlock-module--block--2JyGg";
export var inner = "itemRowBlock-module--inner--1MNrx";
export var textWrap = "itemRowBlock-module--textWrap--1n80w";
export var link = "itemRowBlock-module--link--9B-sE";
export var text = "itemRowBlock-module--text--2rQnH";
export var title = "itemRowBlock-module--title--1B0lw";
export var list = "itemRowBlock-module--list--rs4HE";
export var mediaWrap = "itemRowBlock-module--mediaWrap--3OgYq";